import React from "react";

const badge = "inline-flex items-center max-w-[220px] truncate px-2 py-0.5 rounded-md text-xs font-medium border";

export function freightServiceCategoryStatusCell(row) {
  const on = String(row?.status) === "1";
  return (
    <span
      className={`${badge} ${on ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-gray-200 bg-gray-50 text-gray-600"}`}
    >
      {on ? "Active" : "Inactive"}
    </span>
  );
}

export const FREIGHT_SERVICE_CATEGORY_MASTER_COLUMNS = [
  { key: "id", label: "ID", aliases: [], defaultVisible: false },
  { key: "name", label: "Name", aliases: [], defaultVisible: true },
  { key: "order_no", label: "Order", aliases: ["orderNo"], defaultVisible: true },
  {
    key: "status",
    label: "Status",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightServiceCategoryStatusCell
  },
  { key: "created_by", label: "Created by", aliases: ["createdBy"], defaultVisible: false },
  { key: "updated_by", label: "Updated by", aliases: ["updatedBy"], defaultVisible: false },
  { key: "created_at", label: "Created", aliases: ["createdAt"], defaultVisible: false },
  { key: "updated_at", label: "Updated", aliases: ["updatedAt"], defaultVisible: false }
];
